var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _vm.open
      ? _c(
          "div",
          {
            staticClass: "task-info-footer",
            style: {
              height: _vm.getTransferingHeight(_vm.itemDetail, _vm.index)
            }
          },
          [
            _c("div", { staticClass: "transfer-detail-title" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.transferDetails")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-detail-des" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.itemDetail.sourceCloudType !== "Shares",
                      expression: "itemDetail.sourceCloudType!=='Shares'"
                    }
                  ],
                  staticClass: "transfer-detail-left",
                  attrs: {
                    title: _vm._f("getCatalogTitle")(
                      _vm._f("getCatalog")(_vm.itemDetail.sourceNode)
                    )
                  }
                },
                [
                  _vm._v(_vm._s(_vm.$t("language.common.from")) + ":"),
                  _c(
                    "span",
                    {
                      staticClass: "catelog-color",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toSourceCatalog(_vm.itemDetail)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("getCatalog")(_vm.itemDetail.sourceNode))
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.itemDetail.sourceCloudType === "Shares",
                      expression: "itemDetail.sourceCloudType==='Shares'"
                    }
                  ],
                  staticClass: "transfer-detail-left",
                  attrs: {
                    title: _vm._f("getCatalogTitle")(
                      _vm._f("getCatalogShare")(_vm.itemDetail.sourceNode)
                    )
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.from")) +
                      ":\r\n                "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "catelog-color",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toShareCatalog(_vm.itemDetail)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("getCatalogShare")(_vm.itemDetail.sourceNode)
                        )
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "to-destine transfer-detail-right",
                  attrs: {
                    title: _vm._f("getCatalogTitle")(
                      _vm._f("getCatalog")(_vm.itemDetail.desNode)
                    )
                  }
                },
                [
                  _vm._v(_vm._s(_vm.$t("language.common.to")) + ":"),
                  _c(
                    "span",
                    {
                      staticClass: "catelog-color",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toAimSourceCatalog(_vm.itemDetail)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("getCatalog")(_vm.itemDetail.desNode))
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-detail-des" }, [
              _vm.itemDetail.totalFileCount
                ? _c("div", { staticClass: "transfer-detail-left" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.fileProcess")) + ":"),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.itemDetail.readyTranFileCount) +
                          "/" +
                          _vm._s(_vm.itemDetail.totalFileCount)
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.itemDetail.readedBytes
                ? _c("div", { staticClass: "to-destine" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.dataProcess")) + ":"),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatByte")(_vm.itemDetail.readedBytes)
                        ) +
                          "/" +
                          _vm._s(
                            _vm._f("formatByte")(_vm.itemDetail.totalBytes)
                          )
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-detail-des" }, [
              _vm.itemDetail.taskStartTimeLong
                ? _c("div", { staticStyle: { float: "left" } }, [
                    _vm._v(_vm._s(_vm.$t("language.common.startTime")) + ":"),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("transferTime")(
                            _vm.itemDetail.taskStartTimeLong
                          )
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.itemDetail.itemProgressInfo &&
              _vm.itemDetail.itemProgressInfo.speed
                ? _c("div", { staticClass: "to-destine" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.currentRate")) + ":"),
                    _c("span", [
                      _vm._v(_vm._s(_vm.itemDetail.itemProgressInfo.speed))
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.itemDetail.itemProgressInfo
              ? _c(
                  "div",
                  { staticStyle: { marginTop: "10Px" } },
                  _vm._l(_vm.itemDetail.itemProgressInfo.entities, function(
                    item,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index, staticClass: "task-catelog" },
                      [
                        _c(
                          "div",
                          {
                            class: !_vm.isVip() ? "txt-max" : "txt-max-vip",
                            staticStyle: {
                              float: "left",
                              height: "20Px",
                              lineHeight: "20Px"
                            },
                            attrs: { title: _vm.getTitle(item) }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("getCatalog")(item.fileNode)) +
                                "\\" +
                                _vm._s(item.filename)
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isVip()
                          ? _c("div", [
                              item.rate == -1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "upgradeMulti",
                                      staticStyle: { float: "right" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.switchToPay()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.upgradeMulti")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.rate != -1
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        height: "20Px",
                                        lineHeight: "20Px"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.rate) + "%")]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isVip()
                          ? _c("div", [
                              item.rate && item.rate != -1
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        height: "20Px",
                                        lineHeight: "20Px"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.rate) + "%")]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        height: "20Px",
                                        lineHeight: "20Px"
                                      }
                                    },
                                    [_vm._v("0%")]
                                  )
                            ])
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "task-upgrade" }, [
              _c("div", {
                staticClass: "icon-util shop-cart shop-cart-position"
              }),
              _vm._v(" "),
              !_vm.isVip()
                ? _c("div", { class: _vm.isVip() ? "task-upgrade-des" : "" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.noVip")) +
                        "\r\n            "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isVip()
                ? _c("div", { class: _vm.isVip() ? "task-upgrade-des" : "" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.vipThanks")))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "task-upgrade-button" }, [
              !_vm.isVip()
                ? _c(
                    "button",
                    {
                      staticClass: "upgrade-now",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.switchToPay()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.upgradeNow")))]
                  )
                : _vm._e()
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3d4fcec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3d4fcec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_transfering_detail.vue
// module id = null
// module chunks = 